import {DeleteModalService} from './../services/delete-modal.service';
import {ConfirmationModalComponent} from './../../shared/confirmation-modal/confirmation-modal.component';
import {MasterService} from './../services/master.service';
import {InvoiceModalComponent} from './../../shared/invoice-modal/invoice-modal.component';
import {StockService} from './../services/stocks.service';
import {Component, OnInit, Input, Output, EventEmitter, Injectable} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PaginationInstance} from 'ngx-pagination';
import {CommonAlertService} from '../../services/common-alert.service';
// import moment from 'moment';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {

  public invoice: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count!: number;
  // tslint:disable-next-line:variable-name
  current_page!: number;
  // tslint:disable-next-line:variable-name
  last_page!: number;
  // tslint:disable-next-line:variable-name
  per_page!: number;
  invoicePageId = 'invoicePageId';
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By SI no';

  @Input()
  id!: string;
  @Input()
  maxSize!: number;
  @Output()
  pageChange!: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;

  // tslint:disable-next-line:max-line-length no-shadowed-variable
  constructor(public stockservice: StockService, public dialog: MatDialog, public masterService: MasterService, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) {
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
      console.log('invoice');
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['invoice.view'] == 1 || roles['invoice.add'] == 1 || roles['invoice.edit'] == 1 || roles['invoice.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['invoice.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['invoice.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['invoice.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getInvoiceData();
  }

  getInvoiceData() {
    // let page = e;
    this.masterService.getIndex('/invoices/index', this.filter).subscribe(res => {

      console.log('invoice data', res.data.items);
      
      // @ts-ignore
      this.invoice = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;

      const newData = {
        id: '',
        date: '',
        warehouse_name: '',
        location_name: '',
        net_total: '',
        no_items: '',
        grand_total: ''

      };
      if (this.invoice.length < 10) {
        console.log('is greater than 10');
        
        for ( let i = this.invoice.length; i < 9 ; i++) {
          this.invoice.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });

  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By SI no';
          break;
        case '1':
          this.placeHolder = 'Search By Date';
          break;
        case '2':
          this.placeHolder = 'Search by Product Code';
          break;
        default:
          this.placeHolder = 'Search By SI no';
      }
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(InvoiceModalComponent, {
      minWidth: '90vw',
      disableClose: true,
      data: {}
    }).afterClosed().subscribe(() => this.getInvoiceData());
  }

  openEditDialog(index) {
    const editId = this.invoice[index].id;
    const encID = this.invoice[index].enc_id;
    // this.masterService.getRecordById();

    // tslint:disable-next-line:triple-equals
    if (editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(InvoiceModalComponent, {
        minWidth: '90vw',
        disableClose: true,
        data: {
          id: editId,
          enc_Id: encID
        }
      }).afterClosed().subscribe(() => this.getInvoiceData());
    }

  }

  doSearch(): void {

    if (this.searchBy != null) {
      switch (this.searchBy) {
        case '0':
          // tslint:disable-next-line:max-line-length
          Object.assign(this.filter, {search: {type: 'int', field: 'invoice_products.id', text: this.searchTxt}});
          break;

        case '1':
        // if (this.searchTxt && moment(this.searchTxt, 'YYYY-MM-DD', true).isValid()) {
        if (this.searchTxt) {
           // tslint:disable-next-line:max-line-length
          Object.assign(this.filter, {search: {type: 'str', field: 'invoice_products.expire_date', text: this.searchTxt}});
        }
        else{
            this.commonAlertService.showAlertMsg({message: 'Date format should be YYYY-MM-DD'});
        }
        break;

        case '2':
          // tslint:disable-next-line:max-line-length
          Object.assign(this.filter, {search: {type: 'str', field: 'invoice_products.product_code', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: {type: 'int', field: 'invoice_products.id', text: this.searchTxt}});
      }
    }
    this.getInvoiceData();
  }

  doRefresh(): void {
    this.searchTxt = null;
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getInvoiceData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getInvoiceData();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  // Delete the purchase order
  deleteDialog(i): void {
    this.deleteModalService.openModal({
      id: this.invoice[i].id,
      encId: this.invoice[i].enc_id,
      token: localStorage.getItem('token'),
      deleteUrl: '/invoices/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getInvoiceData();
    });
  }
  confirmationModal(i, row) {
    // tslint:disable-next-line:variable-name
    const product_id = row.id;
    // tslint:disable-next-line:no-unused-expression
    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      minWidth: '50vw',
      minHeight: '20vh',
      disableClose: true,
      data: product_id
    }).afterClosed().subscribe(() => this.ngOnInit());

  }

}
